import { h, Component } from 'preact';
import Store from 'store/store';
import { joinClasses } from 'utils/utils';
import Spinner from 'components/bolt/sectionLoader/spinner';
import s from 'components/bolt/sectionLoader/sectionLoader.sss';

// const isServer = typeof window === 'undefined';

export default class SectionLoader extends Component {
	constructor(props) {
		super(props);
		this.load = this.load.bind(this);
		this.determineLoad = this.determineLoad.bind(this);
		this.loadSectionEvent = this.loadSectionEvent.bind(this);

		// if (!isServer && window.location.hash) {
		// 	const landingId = window.location.hash.replace('#', '');
		// 	const noSlug = accessNested(Store.get(), `appData.pages.${landingId}`, false);
		// 	if (!noSlug) {
		// 		const pages = accessNested(props, 'appData.pages', null);
		// 		const parentSection = pages && Object.keys(pages).filter(page => pages[page].slug === landingId)[0];
		// 		if (props.id === parentSection) {
		// 			this.load();
		// 		}
		// 	}
		// 	if (props.id === landingId) {
		// 		this.load();
		// 	}
		// }
	}

	componentDidMount() {
		let requested = Store.emit('GET_REQUESTED_SECTIONS') || [];
		if (requested.includes(this.props.id)) {
			return this.load();
		}
		Store.on('LOAD_SECTION', this.loadSectionEvent);
		window.addEventListener('scroll', this.determineLoad, true);
		this.determineLoad();
	}

	componentWillUnmount() {
		Store.off('LOAD_SECTION', this.loadSectionEvent);
		window.removeEventListener('scroll', this.determineLoad, true);
	}

	componentDidUpdate() {
		if (!this.emitted && this.$component) {
			this.emitted = true;
			Store.emit('SECTION_LOADED', this.props.id, this.$component.base || this.$component);
		}
	}

	loadSectionEvent(id) {
		if (id !== this.props.id) {
			return;
		}
		this.load();
		Store.off('LOAD_SECTION', this.loadSectionEvent);
	}

	determineLoad() {
		const rect = this.base.getBoundingClientRect();
		if (rect.top <= window.innerHeight + 100) {
			window.removeEventListener('scroll', this.determineLoad, true);
			this.load();
		}
	}

	async load() {
		if (this.loadStarted) {
			return;
		}
		this.loadStarted = true;

		const { getter } = this.props;
		this.component = await (typeof getter === 'function' ? getter() : getter);
		this.setState({ showComponent: true });
	}

	render(props) {
		if (!this.state.showComponent) {
			return (
				<div class={s.loading}>
					<Spinner appData={props.appData} />
				</div>
			);
		}

		const Comp = this.component.default;
		const { getter, singlePage, ...compProps } = props;

		return <Comp {...compProps} class={joinClasses({ fullPage: singlePage })} ref={e => this.$component = e} />;
	}
}
